export default {
    data() {
        return {
            // 搜索条件
            form: {
                // 课程编号
                courseNumber: '',
                // 课程名称
                courseName: '',
                // 课程类型
                courseType: '',
                // 课程分类
                courseClassification: '',
                // 课程分类路径
                path: '',
                // 大于或等于报名期限
                time_egt: '',
                // 小于或等于报名期限
                time_eglt: '',
                // 课程状态
                courseState: '',
                // 申报年度
                year: '',
                // 课程简介
                desc: '',
                // 讲师
                teacher: '',
                // 讲师简介
                teacherDesc: '',
                // 是否上架
                shelves: false,
                // 是否禁用
                disable: false,
                // 课程标签
                label: '',
                // 提供者
                provider: '',
                // 备注
                remark: '',
                // 所属中心
                center: '',
            },
            // 课程类型
            courseType: [
                {
                    id: 1,
                    label: '公需课',
                    value: '公需课',
                },
                {
                    id: 2,
                    label: '专业课',
                    value: '专业课',
                },
                {
                    id: 3,
                    label: '选修课',
                    value: '选修课',
                },
                {
                    id: 4,
                    label: '其他',
                    value: '其他',
                }
            ],
            // 课程分类
            courseClassification: [
                {
                    id: 1,
                    label: '园林'
                },
                {
                    id: 2,
                    label: '计算机'
                },
            ],
            // 课程状态
            courseState: [
                {
                    id: 1,
                    label: '未上架',
                    value: '未上架',
                },
                {
                    id: 2,
                    label: '待审核',
                    value: '待审核',
                },
                {
                    id: 3,
                    label: '已上架',
                    value: '已上架',
                },
                {
                    id: 4,
                    label: '已过期',
                    value: '已过期',
                },
            ],
            // 课程标签
            courseLabels: [
                {
                    id: 1,
                    label: '标签1',
                    value: '标签1'
                },
                {
                    id: 2,
                    label: '标签2',
                    value: '标签2'
                },
            ],
            // 所属中心
            center: [
                {
                    id: 1,
                    label: '郑州',
                    value: '郑州'
                }
            ],
            // 表格数据
            tableData: [
                {
                    id: 1,
                    courseNumber: '65445641674865',
                    courseName: '有效课堂教学与案例',
                    courseType: '专业课',
                    imageUrl: 'images/default.png',
                    courseClassification: '中小学教育',
                    path: '中小学分类路径',
                    courseState: '已上架',
                    year: 2020,
                    period: 45,
                    teacher: '讲师',
                    courseDesc: '好课好课程好课好课程',
                    teacherDesc: '好老师',
                    timeEgt: '2020-01-01',
                    timeEglt: '2020-02-02',
                    entryFee: 15,
                    shelves: true,
                    displayPosition: '显示位置',
                    previewLink: '预览视频链接',
                    disable: false,
                    provider: '提供者',
                    remark: '备注',
                },
                {
                    id: 2,
                    courseNumber: '65445641674865',
                    courseName: '有效课堂教学与案例',
                    courseType: '专业课',
                    imageUrl: 'images/default.png',
                    courseClassification: '中小学教育',
                    path: '中小学分类路径',
                    courseState: '已上架',
                    year: 2020,
                    period: 45,
                    teacher: '讲师',
                    courseDesc: '好课好课程好课好课程',
                    teacherDesc: '好老师',
                    timeEgt: '2020-01-01',
                    timeEglt: '2020-02-02',
                    entryFee: 15,
                    shelves: true,
                    displayPosition: '显示位置',
                    previewLink: '预览视频链接',
                    disable: false,
                    provider: '提供者',
                    remark: '备注',
                },
                {
                    id: 3,
                    courseNumber: '65445641674865',
                    courseName: '有效课堂教学与案例',
                    courseType: '专业课',
                    imageUrl: 'images/default.png',
                    courseClassification: '中小学教育',
                    path: '中小学分类路径',
                    courseState: '已上架',
                    year: 2020,
                    period: 45,
                    teacher: '讲师',
                    courseDesc: '好课好课程好课好课程',
                    teacherDesc: '好老师',
                    timeEgt: '2020-01-01',
                    timeEglt: '2020-02-02',
                    entryFee: 15,
                    shelves: true,
                    displayPosition: '显示位置',
                    previewLink: '预览视频链接',
                    disable: false,
                    provider: '提供者',
                    remark: '备注',
                },
                {
                    id: 4,
                    courseNumber: '65445641674865',
                    courseName: '有效课堂教学与案例',
                    courseType: '专业课',
                    imageUrl: 'images/default.png',
                    courseClassification: '中小学教育',
                    path: '中小学分类路径',
                    courseState: '已上架',
                    year: 2020,
                    period: 45,
                    teacher: '讲师',
                    courseDesc: '好课好课程好课好课程',
                    teacherDesc: '好老师',
                    timeEgt: '2020-01-01',
                    timeEglt: '2020-02-02',
                    entryFee: 15,
                    shelves: true,
                    displayPosition: '显示位置',
                    previewLink: '预览视频链接',
                    disable: false,
                    provider: '提供者',
                    remark: '备注',
                },
            ],
            // 已选择的表格行
            selections: [],
            // 已选择的表格行的id
            selectionIds: [],
            // 导入课程对话框
            importCourseDialog: false,
            // 导入附件对话框
            importAccessoryDialog: false,
            // 下载导入模板
            download: '',
            // 上传的课程导入地址
            address01: '',
            // 上传的附件导入地址
            address02: '',
            // 新增课程对话框
            addCourseDialog: false,
            // 新增课程的数据
            addform: {
                courseNumber: '',
                courseName: '',
                courseType: '',
                courseClassificatio: '',
                path: '',
                time_egt: '',
                time_eglt: '',
                entryFee: '',
                shelves: true,
                courseState: '',
                year: '',
                period: '',
                teacher: '',
                displayPosition: '',
                previewLink: '',
                disable: false,
                label: '',
                provider: '',
                remark: '',
                imageUrl: '',
                desc: '',
                teacherDesc: '',
                courseDetail: '',
            },
            // 上传图片的地址
            address03: '',
            // 新增课程中的课程资源数据
            courseTableData: [
                {
                    id: 1,
                    title: '标题111',
                    type: '选修课',
                    fileName: '视频1',
                    label: '标签1',
                    fileLength: '300',
                    operation: '操作',
                },
                {
                    id: 2,
                    title: '标题111',
                    type: '选修课',
                    fileName: '视频1',
                    label: '标签1',
                    fileLength: '300',
                    operation: '操作',
                },
                {
                    id: 3,
                    title: '标题111',
                    type: '选修课',
                    fileName: '视频1',
                    label: '标签1',
                    fileLength: '300',
                    operation: '操作',
                },
            ],
            // 新增课程中需要删除的课程资源的id
            deleteIds: [],
            // 上传资源的地址
            address04: '',
            // 上传资源的标题
            title: '',
            // 上传资源的标签
            label: '',
            // 修改课程对话框
            editCourseDialog: false,
            // 修改课程的数据
            editform: {
                courseNumber: '',
                courseName: '',
                courseType: '',
                courseClassificatio: '',
                path: '',
                time_egt: '',
                time_eglt: '',
                entryFee: '',
                shelves: true,
                courseState: '',
                year: '',
                period: '',
                teacher: '',
                displayPosition: '',
                previewLink: '',
                disable: false,
                label: '',
                provider: '',
                remark: '',
                imageUrl: '',
                desc: '',
                teacherDesc: '',
                courseDetail: '',
            },
            // 修改课程中需要删除的课程资源的id
            deleteIds2: [],
            // 总条数
            total: 20,
            // 当前页
            currentPage: 1,
            // 每页显示条数
            pageSize: 10,
        }
    },
    methods: {
        // 搜索
        search() {
            console.log(this.form);
        },

        // 当选择项发生变化时会触发该事件
        handleSelectionChange(selections) {
            this.selections = selections;
            // 取出选择的表格行的id
            this.selectionIds = selections.map(item => item.id);
        },

        // 点击新增课程按钮
        handleNewCourse() {
            this.addCourseDialog = true;
        },

        // 上传
        httpreq01(q) {
            this.$upload(this.address01, q).then(res => {
                this.$message({
                    message: '导入完成',
                    type: 'success'
                });
            });
        },

        // 上传
        httpreq02(q) {
            this.$upload(this.address02, q).then(res => {
                this.$message({
                    message: '导入完成',
                    type: 'success'
                });
            });
        },

        // 上传
        httpreq03(q) {
            this.$upload(this.address03, q).then(res => {
                this.$message({
                    message: '导入完成',
                    type: 'success'
                });
            });
        },

        // 上传
        httpreq04(q) {
            this.$upload(this.address04, q).then(res => {
                this.$message({
                    message: '导入完成',
                    type: 'success'
                });
            });
        },

        // 添加课程
        addCourse() {
            this.addCourseDialog = false;
            this.$message.success('添加课程成功！');
        },

        // 当选择项发生变化时会触发该事件
        handleSelectionChange2(selections) {
            // 取出选择的表格行的id
            this.deleteIds = selections.map(item => item.id);
        },

        // 删除选中的课程资源
        deleteCourseResources() {
            // 先判断是否有选择记录
            if (this.deleteIds.length === 0) {
                this.$message.warning('抱歉！请选择一条记录！');
                return;
            }
        },

        // 点击修改课程按钮
        handleEditCourse() {
            // 先判断是否有选择记录且最多选择一条记录
            if (this.selectionIds.length === 0 || this.selectionIds.length !== 1) {
                this.$message.warning('抱歉！请选择一条记录！');
                return;
            }

            // 发送请求赋值
            this.editform = {
                courseNumber: 'JXJY_C20147560',
                courseName: '有效课堂教学与案例',
                courseType: '专业课',
                courseClassificatio: '中小学教育',
                path: '中小学教育',
                time_egt: '2020-02-02',
                time_eglt: '2020-02-02',
                entryFee: '12',
                shelves: true,
                courseState: '已上架',
                year: '2020',
                period: '10',
                teacher: '郭景扬',
                displayPosition: '',
                previewLink: '',
                disable: false,
                label: '',
                provider: '',
                remark: '',
                imageUrl: 'images/default_course.jpg',
                desc: '本系列主要以质量管理、有效课堂这两大方面为主。',
                teacherDesc: '郭景扬，原华东师范大学教育管理学院副院长、教育部中学校长培训中心副主任。现任华东师范大学光华学院副院长。上海市中学历史教材编写组副组长等。',
                courseDetail: '课程详情。。。。。。。。。',
            },

                // 显示修改课程对话框
                this.editCourseDialog = true;
        },

        // 当选择项发生变化时会触发该事件
        handleSelectionChange3(selections) {
            // 取出选择的表格行的id
            this.deleteIds2 = selections.map(item => item.id);
        },

        // 删除选中的课程资源
        deleteCourseResources2() {
            // 先判断是否有选择记录
            if (this.deleteIds2.length === 0) {
                this.$message.warning('抱歉！请选择一条记录！');
                return;
            }
        },

        // 保存修改课程
        editCourse() {
            this.$message.success('修改成功！');
            this.editCourseDialog = false;
        },

        // 点击删除课程按钮
        handleDeleteCourse() {
            // 先判断是否有选择记录且最多选择一条记录
            if (this.selectionIds.length === 0) {
                this.$message.warning('抱歉！请选择一条记录！');
                return;
            }
            // 发送请求删除
            this.$message.success('删除成功！');
        },

        // 每页显示条数改变时调用
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
        },

        // 当前页改变时调用
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage;
        },
    },
    filters: {
        shelvesFilter(value) {
            return value ? '已上架' : '未上架';
        },

        disableFilter(value) {
            return value ? '已禁用' : '未禁用';
        }
    }
}